export default "__VITE_ASSET__DZ4Ex0pE__"